<template>
  <div class="d-flex flex-column flex-md-row align-items-center p-3 px-md-4 mb-3 bg-white border-bottom box-shadow">
    <nav class="my-0 mr-md-auto">
      <b-spinner class="my-0 mr-md-auto p-2 spinner-border-sm" variant="success" label="connecting" v-if="!isConnected && !isConnectionFailed"></b-spinner>
      <span class="my-0 badge badge-warning" v-if="isConnectionFailed">Geen connectie</span>
      <span class="my-0 badge badge-success" v-if="isConnected">Verbonden</span>
    </nav>
    <nav class="my-2 my-md-0 mr-md-3 nav nav-pills">
      <router-link class="nav-item nav-link" to="/">Home</router-link>
      <!--<router-link class="nav-item nav-link" to="/quiz">Quiz</router-link>-->
      <router-link class="nav-item nav-link" to="/joinedgame" v-if="isConnected && joinedGame">Huidige spel</router-link>
      <router-link class="nav-item nav-link" to="/admingame" v-if="isConnected && createdGame">Beheer game</router-link>
    </nav>
    <!--<a class="btn btn-outline-primary" href="#">Sign up</a>-->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Menu',
  computed: {
    ...mapGetters({
      isConnected: 'quiz/connected',
      isConnectionFailed: 'quiz/connectionFailed',
      createdGame: 'quiz/createdGame',
      joinedGame: 'quiz/joinedGame'
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
nav a:hover,
nav a.router-link-exact-active,
.router-link-exace-active {
  background-color: #007bff;
  cursor: pointer,
}
*/
</style>
